import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom'
import apiClient from '../../apiClient';
import {
    Button,
    TextField,
    Box,
    Stack,
    Divider,
    Typography,
    FormControlLabel,
    Checkbox,
} from '@mui/material';
import { containsAllRequiredFields } from '../../components/helper';
import { HandleAuthError, GenericStackTraceValidator } from '../universal/Alert';
import { getStore } from '../../Store'
const store = getStore();

const EditNetworkRun = () => {
    const { push } = useHistory();
    const currentNetworkRun = store.currentNetworkRun;
    const [networkRun, setNetworkRun] = useState({ "id": currentNetworkRun.id });
    const [isArchived, setIsArchived] = useState(currentNetworkRun.is_archived)
    const [isSubmitButtonDisabled, setSubmitButtonDisabled] = useState(false);

    useEffect(() => {
        apiClient.post(
            "https://us-central1-airy-semiotics-297902.cloudfunctions.net/interactive-density-network",
            { "function_to_execute": "Select_Row_From_Table", "table": "network_run", "identifier_column_name": "id", "value": currentNetworkRun.id  }
        ).then(({ data }) => {
            setNetworkRun(data)
        }).catch(function (error) {
            if (error?.response?.status === 401) {
                HandleAuthError()
            } else {
                console.log(error?.response?.data)
                alert(error?.response?.data)    
            }
        });
    }, []);

    const requiredFields = [
    ];

    const toggleIsArchived = () => {
        setIsArchived(!isArchived)
    }


    const setNetworkRunFields = ({ key, value }) => {
        if (typeof value === 'string') {
            value = value.replaceAll("'", "’")
        }
        networkRun[key] = value;
        setNetworkRun(networkRun)
        const enableSubmitButton = containsAllRequiredFields({ requiredFields, object: networkRun })
        setSubmitButtonDisabled(!enableSubmitButton)
    }

    const editNetworkRun = (networkRun) => {
        apiClient.post(
            "https://us-central1-airy-semiotics-297902.cloudfunctions.net/interactive-density-network",
            {
                "function_to_execute": "Edit_Network_Run",
                "id": currentNetworkRun.id,
                "description": networkRun.description,
                "is_archived": isArchived,
            }
        ).then(({ data }) => {
            store.updateSuccessMessage("Successfully edited Network Run!")
            push('/network-runs')
        }).catch(function (error) {
            if (error?.response?.status === 401) {
                HandleAuthError()
            } else {
                console.log(error?.response.data)
                alert(error?.response.data)
                const stackTraceMessage = GenericStackTraceValidator(error.response?.data, "NetworkRun")
                if (stackTraceMessage != null) {
                    store.updateErrorMessage(stackTraceMessage)
                } else {
                    store.updateErrorMessage("Error while editing Network Run")
                }
            }
        })
    }

    const generateVisualizations = (networkRun) => {
        store.updateStatusMessage("Generating visualizations for " + currentNetworkRun.name)
        apiClient.post(
            "https://us-central1-airy-semiotics-297902.cloudfunctions.net/interactive-density-network",
            {
                "function_to_execute": "Run_Centralized_Python_Analytics",
                "network_run_id": currentNetworkRun.id,
            }
        ).then(({ data }) => {
            store.updateSuccessMessage("Successfully generated visualizations!")
            push('/network-runs')
        }).catch(function (error) {
            if (error?.response?.status === 401) {
                HandleAuthError()
            } else {
                console.log(error?.response.data)
                alert(error?.response.data)
                const stackTraceMessage = GenericStackTraceValidator(error.response?.data, "NetworkRun")
                if (stackTraceMessage != null) {
                    store.updateErrorMessage(stackTraceMessage)
                } else {
                    store.updateErrorMessage("Error while editing Network Run")
                }
            }
        })
    }

    const runBatch = () => {
        store.updateStatusMessage("Running Batch")
        apiClient.post(
            "https://us-central1-airy-semiotics-297902.cloudfunctions.net/interactive-density-network",
            {
                "function_to_execute": "Run_Batch_From_ID",
                "network_batch_id": "",
            }
        ).then(({ data }) => {
            store.updateSuccessMessage("Successfully ran batch!")
            push('/network-runs')
        }).catch(function (error) {
            if (error?.response?.status === 401) {
                HandleAuthError()
            } else {
                console.log(error?.response.data)
                const stackTraceMessage = GenericStackTraceValidator(error.response?.data, "NetworkRun")
                if (stackTraceMessage != null) {
                    store.updateErrorMessage(stackTraceMessage)
                } else {
                    store.updateErrorMessage("Error while running batch")
                }
            }
        })
    }
    return (
        <Box>
            <Typography variant="h6">Edit Network Run ({currentNetworkRun.name})</Typography>
            <Box sx={{ m: 2 }}>
                <Stack direction="row" spacing={1}>
                    <TextField
                        id="description"
                        label="Description"
                        onChange={(event) => setNetworkRunFields({ key: event.target.id, value: event.target.value })}
                        required
                        defaultValue={currentNetworkRun.description}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    <FormControlLabel
                        label="Archived"
                        control={
                            <Checkbox
                                checked={isArchived}
                                onChange={(event) => toggleIsArchived()}
                                label="Archived"
                                size="large"
                            />
                        }
                    />
                </Stack>
            </Box>
            <Box sx={{ m: 2 }}>
                <Stack direction="row" spacing={1} justifyContent="flex-end">
                    <Button
                        variant="contained"
                        onClick={() => generateVisualizations(networkRun)}
                        disabled={isSubmitButtonDisabled}
                    >
                        Generate Analytics Visualizations
                    </Button>
                </Stack>
            </Box>
            {/*<Box sx={{ m: 2 }}>*/}
            {/*    <Stack direction="row" spacing={1} justifyContent="flex-end">*/}
            {/*        <Button*/}
            {/*            variant="contained"*/}
            {/*            onClick={() => runBatch()}*/}
            {/*            disabled={isSubmitButtonDisabled}*/}
            {/*        >*/}
            {/*            Run 100 Batch*/}
            {/*        </Button>*/}
            {/*    </Stack>*/}
            {/*</Box>*/}
            <Divider />
            <Box sx={{ m: 2 }}>
                <Stack direction="row" spacing={1} justifyContent="flex-end">
                    <Button onClick={() => push('/network-runs')}>Cancel</Button>
                    <Button
                        variant="contained"
                        onClick={() => editNetworkRun(networkRun)}
                        disabled={isSubmitButtonDisabled}
                    >
                        Submit
                    </Button>
                </Stack>
            </Box>
        </Box>
    )
}

export default EditNetworkRun